import { createSlice } from "@reduxjs/toolkit";
import { addDays, endOfMonth, startOfMonth } from "date-fns";
import { uiToServer } from "../../../app/utils/utilityFunctions";

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: {
    selectedDateRange: {
      value: 1,
      from: uiToServer(startOfMonth(new Date())),
      to: uiToServer(endOfMonth(addDays(new Date(), 1))),
    },
  },
  reducers: {
    setSelectedDashboardDateRange: (state, { payload }) => {
      state.selectedDateRange = payload;
    },
  },
});

export const { setSelectedDashboardDateRange } = dashboardSlice.actions;

export const selectDashboardSelectedDateRange = (state) => state.dashboard.selectedDateRange;

export default dashboardSlice.reducer;
